<template>
  <v-container class="buscador-sucursales-container">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="textoBusqueda"
          label="Buscar sucursal por nombre, dirección, ciudad o provincia..."
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          @input="onFiltroChange"
          class="buscador-input"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'BuscadorSucursales',
  data () {
    return {
      textoBusqueda: ''
    }
  },
  methods: {
    onFiltroChange () {
      this.$emit('filtro-change', {
        textoBusqueda: this.textoBusqueda || ''
      })
    }
  }
}
</script>

<style scoped>
.buscador-sucursales-container {
  padding: 24px 16px;
}

.buscador-input {
  transition: all 0.3s ease;
}

.buscador-input:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
